/**
 * Demo contact records, lifted from the prototype's
 * `docs/html/assets/js/contacts-data.js`.
 *
 * Dates are plain ISO day strings — no time, no zone — so anniversary maths
 * never drifts across timezones. That matters: a birthday greeting sent a day
 * early because the server is in UTC and the contact is in Auckland is worse
 * than not sending one.
 */
export const contacts = [
  { id:'CT-001', name:'Elena Moreau', title:'CEO', company:'Northwind Group',
    email:'e.moreau@northwind.io', phone:'+1 415 555 0101', role:'Economic buyer', tone:'pill-rose',
    influence:'High', channel:'Email', lastTouch:'Today', owner:'Jonas Weber',
    birthday:'1976-09-07', joinedCompany:'2014-04-02', customerSince:'2019-06-11' },

  { id:'CT-002', name:'Sofia Marchetti', title:'Head of Operations', company:'Northwind Analytics',
    email:'s.marchetti@northwind.io', phone:'+1 415 555 0142', role:'Champion', tone:'pill-green',
    influence:'High', channel:'Phone', lastTouch:'Today', owner:'Aisha Kapoor',
    birthday:'1987-11-19', joinedCompany:'2019-09-08', customerSince:'2019-06-11' },

  { id:'CT-003', name:'Robert Chen', title:'Procurement Manager', company:'Northwind Group',
    email:'r.chen@northwind.io', phone:'+1 415 555 0118', role:'Blocker', tone:'pill-amber',
    influence:'Medium', channel:'Email', lastTouch:'2 days', owner:'Jonas Weber',
    birthday:'1988-09-12', joinedCompany:'2021-01-18', customerSince:'2019-06-11' },

  { id:'CT-004', name:'Ravi Deshmukh', title:'VP Engineering', company:'Helix Robotics',
    email:'r.deshmukh@helixrobotics.com', phone:'+48 22 555 0188', role:'Technical DM', tone:'pill-violet',
    influence:'High', channel:'Teams', lastTouch:'Yesterday', owner:'Marek Kowalski',
    birthday:'1982-03-30', joinedCompany:'2016-07-25', customerSince:'2018-09-15' },

  { id:'CT-005', name:'Grace Adeyemi', title:'Procurement Lead', company:'Meridian Health',
    email:'g.adeyemi@meridianhealth.com', phone:'+1 617 555 0119', role:'Buyer', tone:'pill-sky',
    influence:'Medium', channel:'Phone', lastTouch:'4 days', owner:'Aisha Kapoor',
    birthday:'1991-09-04', joinedCompany:'2020-02-10', customerSince:'2020-05-04' },

  { id:'CT-006', name:'Tomas Berg', title:'CTO', company:'Vertex Media',
    email:'t.berg@vertexmedia.co.uk', phone:'+44 20 7555 0164', role:'Technical DM', tone:'pill-violet',
    influence:'High', channel:'Email', lastTouch:'1 week', owner:'Sara Brandt',
    birthday:'1979-06-23', joinedCompany:'2022-09-20', customerSince:'2023-03-02' },

  { id:'CT-007', name:'Lena Okonjo', title:'Director, Operations', company:'Cobalt Energy',
    email:'l.okonjo@cobaltenergy.no', phone:'+47 22 555 0173', role:'Influencer', tone:'pill-gray',
    influence:'Medium', channel:'WhatsApp', lastTouch:'3 days', owner:'Sara Brandt',
    birthday:'1983-09-28', joinedCompany:'2018-11-05', customerSince:'2022-04-19' },

  { id:'CT-008', name:'Mei Tanaka', title:'Head of IT', company:'Kyoto Systems',
    email:'m.tanaka@kyotosystems.jp', phone:'+81 75 555 0198', role:'Champion', tone:'pill-green',
    influence:'High', channel:'Email', lastTouch:'Today', owner:'Jonas Weber',
    birthday:'1985-01-08', joinedCompany:'2017-10-01', customerSince:'2021-10-01' },

  { id:'CT-009', name:'Hugo Alvarez', title:'CFO', company:'Solaris Retail',
    email:'h.alvarez@solarisretail.es', phone:'+34 91 555 0127', role:'Economic buyer', tone:'pill-rose',
    influence:'High', channel:'Phone', lastTouch:'5 days', owner:'Diego Ramos',
    // Leap-day birthday: exercises the 29 Feb fallback in non-leap years
    birthday:'1980-02-29', joinedCompany:'2015-09-14', customerSince:'2024-01-22' },

  { id:'CT-010', name:'Peter Novak', title:'Plant Manager', company:'Danube Steel',
    email:'p.novak@danubesteel.cz', phone:'+420 2 5555 0141', role:'End user', tone:'pill-gray',
    influence:'Low', channel:'Phone', lastTouch:'2 weeks', owner:'Marek Kowalski',
    birthday:'1975-12-02', joinedCompany:'2009-09-21', customerSince:'2020-08-30' },

  { id:'CT-011', name:'Anna Kowalczyk', title:'COO', company:'Helix Robotics',
    email:'a.kowalczyk@helixrobotics.com', phone:'+48 22 555 0190', role:'Economic buyer', tone:'pill-rose',
    influence:'High', channel:'Email', lastTouch:'Yesterday', owner:'Marek Kowalski',
    birthday:'1981-09-16', joinedCompany:'2013-03-11', customerSince:'2018-09-15' },

  { id:'CT-012', name:'Nina Patel', title:'Head of IT Security', company:'Meridian Health',
    email:'n.patel@meridianhealth.com', phone:'+1 617 555 0166', role:'Technical DM', tone:'pill-violet',
    influence:'High', channel:'Teams', lastTouch:'6 days', owner:'Aisha Kapoor',
    birthday:'1990-05-12', joinedCompany:'2021-09-27', customerSince:'2020-05-04' }
];
